export default function Skeleton() {
  return (
    <div className="transition-all duration-500 ease-in-out">
      <div className="pt-5 pb-12 transition-opacity duration-300 opacity-100">
        <div className="flex justify-between items-start mb-4">
          <div>
            <div className="h-8 bg-gray-200 rounded w-48 mb-4 animate-pulse"></div>
            <div className="h-6 bg-gray-200 rounded md:w-[600px] w-64 animate-pulse"></div>
          </div>
        </div>
      </div>
      
      <div className="p-1">
        <div className="flex flex-col lg:flex-row gap-6 transition-all duration-500 ease-in-out relative">
          {/* 지도 스켈레톤 */}
          <div className="lg:w-3/4 transition-all duration-500 ease-in-out">
            <div className="sticky top-4">
              <div className="transition-all duration-500 ease-in-out h-[400px] lg:h-[720px] rounded-lg bg-gray-200 animate-pulse"></div>
            </div>
          </div>
          
          {/* 카드 목록 스켈레톤 */}
          <div className="lg:w-1/4 transition-all duration-500 ease-in-out">
            <div className="mb-4">
              <div className="flex justify-between items-center mb-3">
                <div className="h-6 bg-gray-200 rounded w-24 animate-pulse"></div>
              </div>
              <div className="h-4 bg-gray-200 rounded w-48 animate-pulse"></div>
            </div>
            
            <div className="space-y-4">
              {[...Array(6)].map((_, index) => (
                <div key={index} className="p-3 rounded-lg bg-gray-50">
                  <div className="flex items-start gap-3">
                    <div className="w-4 h-4 rounded-full bg-gray-300 animate-pulse mt-1 flex-shrink-0"></div>
                    <div className="flex-1 min-w-0">
                      <div className="h-6 bg-gray-300 rounded w-3/4 mb-5 animate-pulse"></div>
                      <div className="h-4 bg-gray-300 rounded w-full mb-3 animate-pulse"></div>
                      <div className="h-4 bg-gray-300 rounded w-2/3 mb-3 animate-pulse"></div>
                      <div className="h-4 bg-gray-300 rounded w-1/2 mb-3 animate-pulse"></div>
                      <div className="h-4 bg-gray-300 rounded w-1/3 animate-pulse"></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}